import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchMyTemplates } from '@/api/questionnaires';
import type { MyTemplatesListParams } from '../-types';
import { buildTemplatesFilterJson } from '../-utils/listParams';

export const myTemplatesKeys = {
  all: ['questionnaires', 'my-templates'] as const,
  list: (params: MyTemplatesListParams) =>
    [...myTemplatesKeys.all, 'list', params] as const,
};

function buildQs(params: MyTemplatesListParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(params.count));
  qs.set('filter', buildTemplatesFilterJson(params));
  qs.set('myTemplates', 'true');
  if (params.sort) qs.set('sort', params.sort);
  return qs.toString();
}

export function myTemplatesQueryOptions(params: MyTemplatesListParams) {
  return queryOptions({
    queryKey: myTemplatesKeys.list(params),
    queryFn: () => fetchMyTemplates(buildQs(params)),
  });
}

export function useMyTemplatesQuery(params: MyTemplatesListParams) {
  return useQuery(myTemplatesQueryOptions(params));
}
